export class EmptyArrayError extends Error {}
